import React from 'react'
import Show from 'services/Show';
import ShowResult from 'services/ShowResult';
import { prepareUrl }               from 'services/DataSource';
import { handleErrors, formatDate } from 'services/utils'
import { fciGroups, showClasses } from 'services/constants'
import { Spinner } from 'components/atoms';
import CollapsibleFieldset from 'components/CollapsibleFieldset';

const SECTIONS = [
  'Male Junior',
  'Male CACIB',
  'Male Veteran',
  'Female Junior',
  'Female CACIB',
  'Female Veteran',
];

export default class ShowCRUFTSreport extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      showResults: [],
      breedsByGroup: [],
      sectionsToShow: [1,2,4,5],
      showId: match.params.id,
      successSave: false,
    }
    this.mounted = false;
    this.changed = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.getDogs(this.state.showId).then(({show, dogs, breeds}) => {
      if (this.mounted) {
        const breedsByGroup = fciGroups.map(group => {
          const groupedBreeds = breeds.filter(breed => breed.fci_group === group.id)
          return {...group, breeds: groupedBreeds}; 
        });
        show = new Show(show);
        this.setState( { show, breedsByGroup, dogs, loading: false } );
      }
    }).catch((request) => {
      this.setState({loading: false});
      handleErrors(request);
    });
    ShowResult.query({show_id: this.state.showId, report_type: 2}, null, true).then(data => {
      this.setState({ showResults: data });
    }).catch((request) => {
      handleErrors(request);
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  saveChanges = (e) => {
    e.preventDefault();
    const show = this.state.show;
    const showResults = this.state.showResults;
    this.setState({ successSave: false, busy:true });
    ShowResult.saveResults({show_id: show.id, report_type: 2, breeds: showResults}).then((items) => {
      if (!this.mounted) return; 
      this.setState({ successSave: true, busy: false });
      this.changed = false;
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  groupExpertChosen = ({target}) => {
    const groupId = parseInt((target.id || '').replace(/\D/g,''));
    const expertId = parseInt(target.value);
    if (groupId >= 0 && expertId) {
      const show = this.state.show;
      const groupExpert = show.invited_experts.find(expert => expert.id === expertId);
      const group = this.state.breedsByGroup.find(group => group.id === groupId);
      if (groupExpert && group) {
        group.breeds.forEach(breed => {
          show.breed_experts_map[breed.id] = groupExpert.id;  
        });
        this.setState({ show });
        this.changed = true;
      }
    }
  }

  dogChosen = ({target}) => {
    if (!target.dataset || !target.dataset.breed_id || !target.dataset.section) {
      console.error("Dog chosen target" + target.id +" has no breed_id or section in dataset.");
      return false;
    }
    const breedId = target.dataset.breed_id * 1; 
    const section = target.dataset.section * 1;
    const dogId = target.value * 1;
    let found = false;
    let showResults = this.state.showResults.map(res => {
      if (res.breed_id === breedId && res.section === section) {
        found = true;
        res.dog_id = dogId;
      }
      return res;
    });
    if (!found) {
      showResults.push({
        breed_id: breedId,
        section: section,
        dog_id: dogId,
      });
    }
    this.changed = true; 
    this.setState({ showResults });
  }

  toggleSection = ({target}) => {
    const checked = target.checked;
    const sectionNum = target.name.replace(/\D/g,'')*1;
    let sectionsToShow;
    if (checked) {
      sectionsToShow = [...this.state.sectionsToShow, sectionNum];
    } else {
      sectionsToShow = this.state.sectionsToShow.filter(sect => sect !== sectionNum);
    }
    this.setState({ sectionsToShow });
  }

  render() {
    const {show, breedsByGroup, dogs, showResults, sectionsToShow, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }
    const groupLinks = <div className="m-3">{breedsByGroup.map(group => (
      <a href={'#fieldset-'+group.id} key={group.id} className="me-3">{group.name}</a>
    ))}</div>;

    const groupedBreeds = breedsByGroup.map(group => {
      let matched = 0;  
      return (
        <CollapsibleFieldset 
           id={"fieldset-"+group.id}
           key={group.id}
           title={group.name + ' ( ' + matched + ' / ' + group.breeds.length + ' )'} 
           open={true}
           className="m-3">
          <BreedsList breeds={group.breeds} sectionsToShow={sectionsToShow} show={show} dogs={dogs} results={showResults} onChange={this.dogChosen} />
        </CollapsibleFieldset>
      )
    });

    const buttons = (
      <div className="row">
        <div className="col-md-12 m-3">
          <button type="button" onClick={this.saveChanges} disabled={this.state.busy || !this.changed} className="btn btn-primary me-2">
            { this.state.busy && <Spinner /> }
            Сохранить
          </button>
          <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
            { this.state.busy && <Spinner /> }
            Назад
          </button>
        </div>
      </div>
    );

    const sectionsList = (
      <div>{
        SECTIONS.map((section, idx) => {
          let sectNum = idx+1;
          return (
            <div key={sectNum} className="form-check form-check-inline">
              <input type="checkbox" id={'sect'+sectNum} className="form-check-input" name={'section'+(sectNum)} 
               checked={sectionsToShow.includes(sectNum)} onChange={this.toggleSection} />
              <label for={'sect'+sectNum} className="form-check-label">{section}</label>
            </div>
          )
        })
      }</div>
    );

    return (
      <div className="container-fluid">
        <h4>Отчет CRUFTS выставки - {showInfo}</h4>
        
        { this.state.successSave && 
         <div className="row alert alert-success">
          Изменения успешно сохранены.
         </div>}

        {loading && <Spinner size="xl" position="centered"/> }
        
        {groupLinks}
        <a href={prepareUrl(`shows/${show.id}/reports/crufts_report.xls`)} className="ms-3">CRUFTS report.xls</a>

        {!loading && buttons}
        {!loading && sectionsList}
        {groupedBreeds}
        {!loading && buttons}

      </div>
    );
  }
}


function BreedsList(props) {
  const {breeds, dogs, results, sectionsToShow, onChange} = props;
  return (
    <ul className="mt-3 mb-3 me-1 ms-0">
      <li key="breed-header" className="row">
        {SECTIONS.map((section, idx) => {
          const sectionNum = idx + 1;
          if (sectionsToShow.includes(sectionNum)) {
            return <div key={sectionNum} className="col">{section}</div>
          }
          return null
        })}
      </li>
      {breeds.map(breed => {
        let males = [];
        let females = []; 
        dogs.forEach(dog => {
          if (dog.breed_id !== breed.id) return;
          let dogClassName = '';
          if (dog.class_in_show && showClasses[dog.class_in_show]) {
            dogClassName = showClasses[dog.class_in_show].name_short_ru
          }
          const option = <option key={dog.id} value={dog.id}>
            {dog.catalog_number}. {dogClassName} - {dog.name}
          </option>;
          if (dog.sex === 'male') {
            males.push(option);
          } else {
            females.push(option);
          }
        });
        
        let winners = {};
        results.forEach(res => {
          if (res.breed_id === breed.id) {
            winners[res.section] = res.dog_id;
          }
        });

        return (
          <li key={breed.id} className="row">
            <div className="col-12 row mt-4 mb-1">
              <h5 className="col-12">{ breed.fci_num }. { breed.name }</h5>
            </div>
            <div className="col-12 row">
              {SECTIONS.map((section, idx) => {
                const sectionNum = idx + 1;
                if (sectionsToShow.includes(sectionNum)) {
                  return <div className="col" key={sectionNum}>
                    <select id={'breed-male-'+breed.id} data-breed_id={breed.id} 
                      data-section={sectionNum} value={winners[sectionNum] || 0}  onChange={onChange}
                      title={section} className="form-control form-control-sm">
                      <option>---</option>
                      {sectionNum < 4 ? males : females}
                    </select>
                  </div>
                }
                return null;
                })
              }
            </div>
        </li>);
      })}
    </ul>
  );
}